<template>
    <BaseDetails>
        <div class="product split">
            <ResourcePicture alt="" resource-name="/assets/img/gift_voucher.png" />
            <dl class="product__details">
                <dd class="product__name font-weight-bold">
                    {{ order.product.name }} - {{ order.option.description }}
                </dd>
                <dt class="text-muted">{{ $t('shop.email-address') }}:</dt>
                <dd class="font-weight-bold">{{ order.email }}</dd>
            </dl>
        </div>

        <div class="separator"></div>

        <div class="price split">
            <dt class="price__text text-quote">
                <span class="heading tight d-block" v-html="$t('orderCheckout.total')"></span>
            </dt>
            <dd class="price__total text-quote">
                <span class="heading">{{ formatter.format(order.unpaid_amount) }}</span>
            </dd>
        </div>

        <div class="payments" v-if="giftVoucherPayments.length > 0">
            <ol>
                <li class="text-muted" v-for="payment in giftVoucherPayments" :key="payment.id">
                    {{ $t('giftVoucher.infoAmountCredited', { amount: payment.amount.toFixed(2) }) }}
                </li>
            </ol>
        </div>
    </BaseDetails>
</template>

<script>
import BaseDetails from './Base.vue';
import ResourcePicture from '../../../ResourcePicture.vue';

export default {
    name: 'VoucherOrder',
    components: { ResourcePicture, BaseDetails },
    props: ['order', 'advantages', 'formatter', 'giftVoucherPayments'],
};
</script>

<style lang="scss">
.product {
    picture {
        width: 25%;

        & > img {
            width: 100%;
        }
    }
}
</style>

<style lang="scss" scoped>
.product {
    gap: 1.5rem;

    & > .product__details {
        .product__name {
            font-size: large;
        }
    }
}

.price {
    justify-content: space-between;
}

.price__total {
    white-space: nowrap;
}

.payments {
    ol,
    li {
        list-style: none;
        padding: 0;
    }
}

dl,
dd,
dt {
    margin: 0;
    font-weight: inherit;
}
</style>
